const defaultBrand = {
  companyName: '国建兴华',
  systemName: 'HRM系统',
  pageTitle: '国建兴华HRM系统',
  loginTitle: '国建兴华HRM系统',
  sidebarTitle: '国建兴华HRM系统',
  logoUrl: '/logo.png',
  faviconUrl: '/favicon.ico',
  themeColor: '#012372'
}

const runtimeBrand = window.HRM_CONFIG || {}
const brand = Object.assign({}, defaultBrand, runtimeBrand)

function normalizeHex (value) {
  const raw = String(value || '').trim().replace('#', '')
  if (raw.length === 3) {
    return raw.split('').map(char => char + char).join('')
  }
  return raw.length === 6 ? raw : '012372'
}

function hexToRgb (hex) {
  const normalized = normalizeHex(hex)
  return {
    r: parseInt(normalized.slice(0, 2), 16),
    g: parseInt(normalized.slice(2, 4), 16),
    b: parseInt(normalized.slice(4, 6), 16)
  }
}

function setThemeVariables () {
  const root = document.documentElement
  const primary = brand.themeColor || defaultBrand.themeColor
  const primaryRgb = hexToRgb(primary)

  root.style.setProperty('--brand-primary', primary)
  root.style.setProperty('--brand-primary-rgb', `${primaryRgb.r}, ${primaryRgb.g}, ${primaryRgb.b}`)
  root.style.setProperty('--ui-accent', '#426d9f')
  root.style.setProperty('--ui-accent-deep', '#1d3557')
  root.style.setProperty('--ui-accent-soft', '#e7eef8')
  root.style.setProperty('--ui-ink', '#243446')
  root.style.setProperty('--ui-muted', '#6d7b90')
  root.style.setProperty('--ui-border', 'rgba(36, 52, 70, 0.12)')
  root.style.setProperty('--ui-panel', 'rgba(255, 255, 255, 0.86)')
  root.style.setProperty('--ui-panel-strong', 'rgba(255, 255, 255, 0.94)')
  root.style.setProperty('--ui-page-bg', '#e9edf3')
}

export function applyBrandToDocument () {
  document.title = brand.pageTitle
  setThemeVariables()

  const favicon = document.querySelector('link[rel="icon"]') || document.createElement('link')
  favicon.rel = 'icon'
  favicon.href = brand.faviconUrl
  document.head.appendChild(favicon)
}

export default brand
